<template>
  <a class="bottom-content" :class="{ 'wihout-link': !href }" :href="href" target="_blank"
    ><slot></slot>
  </a>
</template>
<script>
export default {
  props: {
    href: {
      type: String,
      default: null
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-content.wihout-link {
  color: var(--primary-color);
  cursor: default;
}
</style>
